import { ColumnsEdit } from "types/models/column-table-edit";

export const checkDataXML: ColumnsEdit = [
  {
    title: "Mã hồ sơ",
    key: "maHoSo",
    dataIndex: "maHoSo",
    width: 50,
  },
  {
    title: "Nội dung",
    key: "noiDung",
    dataIndex: "noiDung",
    width: 150,
  },
  {
    title: "Mô tả lỗi",
    key: "moTaLoi",
    dataIndex: "moTaLoi",
    width: 200,
  },
];
